export const bloodList = [
    { show: "A +ve", value: "AP" },
    { show: "A -ve", value: "AN" },
    { show: "B +ve", value: "BP" },
    { show: "B -ve", value: "BN" },
    { show: "AB +ve", value: "ABP" },
    { show: "AB -ve", value: "ABN" },
    { show: "O +ve", value: "OP" },
    { show: "O -ve", value: "ON" }
]

export const genderList = [
    { show: 'MALE', value: 'MALE' },
    { show: 'FEMALE', value: 'FEMALE' },
    { show: 'OTHER', value: 'OTHER' }
]

export const maritalStatusList = [
    { show: 'SINGLE', value: 'SINGLE' },
    { show: 'MARRIED', value: 'MARRIED' },
    { show: 'SEPARATED', value: 'SEPARATED' }
]

export const pageType = [
    { show: 'MASTER', value: 'Masters' },
    { show: 'TRANSACTION', value: 'Transactions' },
    { show: 'REPORTS', value: 'Reports' },
    { show: 'ADMIN CONTROLS', value: 'AdminAccess' },
]

export const accessoryCategoryList = [
    { show: 'STITCHING ACCESSORIES', value: 'STITCHING' },
    { show: 'PACKING ACCESSORIES', value: 'PACKING' }
]

export const prefixCategory = [
    { show: "DEFAULT", value: "Default" },
    { show: "SPECIFIC", value: "Specific" }
]

export const employeeType = [
    { show: "PERMANENT", value: true },
    { show: "TEMPORARY", value: false }
]

export const statusDropdown = [
    { show: "ACTIVE", value: true },
    { show: "INACTIVE", value: false }
]

export const poTypes = [
    { show: "Grey Yarn", value: "GreyYarn" },
    { show: "Dyed Yarn", value: "DyedYarn" },
    { show: "Grey Fabric", value: "GreyFabric" },
    { show: "Dyed Fabric", value: "DyedFabric" },
    { show: "Accessory", value: "Accessory" },
]

export const creditDebitTypes = [
    { show: "Credit", value: "Credit" },
    { show: "Debit", value: "Debit" },
]
export const paymentTypes = [
    { show: "Against Bill", value: "AgainstBill" },
    { show: "Advance", value: "Advance" },
]

export const paymentModes = [
    { show: "Check", value: "Check" },
    { show: "NEFT", value: "NEFT" },
    { show: "RDGS", value: "RDGS" },
    { show: "IMPS", value: "IMPS" },
    { show: "Upi", value: "Upi" },
    { show: "Cash", value: "Cash" },
]

export const invoiceTypes = [
    { show: "Cash", value: "Cash" },
    { show: "Credit", value: "Credit" },
]


export const payerTypes = [
    { show: "My Payment", value: "My_Payment" },
    { show: "Customer Payment", value: "Customer_Payment" },
]

export const discountTypes = [
    { show: "Flat", value: "Flat" },
    { show: "Percentage", value: "Percentage" }
]

export const diaMeasurementList = [
    { show: "CMS", value: "CMS" },
    { show: "Inches", value: "INCHES" },
    { show: "Open Width", value: "OPENWIDTH" },
    { show: "Tubuler", value: "TUBULER" },
]

export const purchasePrPi = [
    { show: "Purchase Inward", value: "PurchaseInward" },
    { show: "Purchase Return", value: "PurchaseReturn" }
]

export const inwardTypeOptions = [
    { show: "Against Po", value: "AgainstPo" },
    { show: "Direct Inward", value: "DirectInward" }
]

export const processDeliveryOrReturn = [
    { show: "Process Delivery", value: "ProcessDelivery" },
    { show: "Process Return", value: "ProcessReturn" }
]

export const ProcessIOOptions = [
    { show: "GY-GY", value: "GY_GY" },
    { show: "GY-DY", value: "GY_DY" },
    { show: "GY-GF", value: "GY_GF" },
    { show: "DY-DY", value: "DY_DY" },
    { show: "DY-DF", value: "DY_DF" },
    { show: "GF-DF", value: "GF_DF" },
    { show: "DF-DF", value: "DF_DF" },
]


export const deliveryTypes = [
    { show: "To Self", value: "ToSelf" },
    { show: "To Party", value: "ToParty" },

]

export const showEntries = [
    { show: "10", value: "10" },
    { show: "25", value: "25" },
    { show: "50", value: "50" },
    { show: "100", value: "100" },
]

export const approvalFilterOptions = [
    { show: "All", value: "" },
    { show: "Order Confirmed", value: "Order Confirmed" },
    { show: "Approved", value: "Approved" },
    { show: "Waiting For Approval", value: "Waiting For Approval" },
]

export const inHouseOutsideTypes = [
    { show: "IN-HOUSE", value: "INHOUSE" },
    { show: "OUTSIDE", value: "OUTSIDE" },
]

export const salesTypes = [
    { show: "WHOLE SALE", value: "WHOLESALE" },
    { show: "RETAIL", value: "RETAIL" },
]


export const finishedGoodsBillTypes = [
    { show: "DIRECT", value: "DIRECT" },
    { show: "AGAINST DELIVERY", value: "AGAINSTDELIVERY" },
]


export const deliveryOrReceiptTypes = [
    { show: "DELIVERY", value: "DELIVERY" },
    { show: "RECEIPT", value: "RECEIPT" },
]
